import React from "react";

const Footer = () => (
  <div className="footer" >
    <img
      src={process.env.PUBLIC_URL + '/Images/Image2.png'}
      alt=""
    />
  </div>
);

export default Footer;